"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var API_BASE = 'two-factor/v1';

var TwoFactorAuthAPI =
/*#__PURE__*/
function () {
  function TwoFactorAuthAPI() {
    (0, _classCallCheck2.default)(this, TwoFactorAuthAPI);
  }

  (0, _createClass2.default)(TwoFactorAuthAPI, null, [{
    key: "fetchTwoFactorRequiredEnforcement",
    value: function fetchTwoFactorRequiredEnforcement() {
      return _apiClient.default.get(API_BASE + "/two-factor-required-portals");
    }
  }, {
    key: "setTwoFactorRequired",
    value: function setTwoFactorRequired() {
      return _apiClient.default.post(API_BASE + "/two-factor-required-portals");
    }
  }, {
    key: "setTwoFactorNotRequired",
    value: function setTwoFactorNotRequired() {
      return _apiClient.default.delete(API_BASE + "/two-factor-required-portals");
    }
  }]);
  return TwoFactorAuthAPI;
}();

exports.default = TwoFactorAuthAPI;
module.exports = exports.default;